<template>
  <b-modal
    id="login-modal"
    ref="login-modal"
    centered
    hide-header
    hide-footer
    modal-class="coop-modal"
    :no-enforce-focus="true"
  >
    <button
      type="button"
      class="modal-close-button"
      @click.prevent="closeModal"
    >
      <img src="~assets/images/close-button.svg">
    </button>
    <div class="modal-title-holder">
      <h1
        class="modal-title login-title"
      >
        MEMBER LOGIN
      </h1>
    </div>
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group
        id="login-email"
        label="EMAIL"
        label-for="login-email-input"
        label-class="modal-form-label"
      >
        <b-form-input
          id="login-email-input"
          v-model="loginForm.email"
          v-validate="'required|email'"
          name="login-email-input"
          :state="validateState('login-email-input')"
          type="email"
          required
          placeholder="Enter email"
        />

        <b-form-invalid-feedback
          v-if="$coopHelper.isClient()"
          id="login-email-input-feedback"
        >
          {{ veeErrors.first('login-email-input') }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="login-password"
        label="PASSWORD"
        label-for="login-password-input"
        label-class="modal-form-label"
      >
        <div
          class="password-input-holder"
          :class="{
            'is-valid': validateState('login-password-input') === true,
            'is-invalid': validateState('login-password-input') === false
          }"
        >
          <b-form-input
            id="login-password-input"
            v-model="loginForm.password"
            v-validate="'required|verify_password'"
            name="login-password-input"
            :state="validateState('login-password-input')"
            :type="loginPasswordInputType"
            required
            placeholder="Enter password"
          />
          <b-form-invalid-feedback
            v-if="$coopHelper.isClient()"
          >
            {{ veeErrors.first('login-password-input') }}
          </b-form-invalid-feedback>
          <button
            tabindex="-1"
            type="button"
            class="toggle-password-button"
            @click.prevent="viewPassword"
          >
            <img v-if="loginPasswordInputType === 'password'" src="~assets/images/showpass-icon.svg">
            <img v-if="loginPasswordInputType !== 'password'" src="~assets/images/hidepass-icon.svg">
          </button>
        </div>
      </b-form-group>

      <b-button
        type="submit"
        variant="primary"
        class="button -block"
      >
        LOGIN
      </b-button>

      <div class="options row -with-padding">
        <div class="col-12 col-lg-6 option -left-side">
          <a href="#" @click.prevent="openForgotPassword">
            <img src="~assets/images/lock-icon.svg">
            forgot password
          </a>
        </div>
        <div class="col-12 col-lg-6 option -right-side">
          <a href="#" @click.prevent="register">
            <img src="~assets/images/user-icon.svg">
            create an account
          </a>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'LoginModal',
  data () {
    return {
      loginPasswordInputType: 'password',
      loginForm: {
        email: '',
        password: ''
      },
      errorMessages: {
        'login-email-input': {
          required: 'The EMAIL field is required',
          email: 'The EMAIL field must be a valid email'
        },
        'login-password-input': {
          required: 'The PASSWORD field is required',
          verify_password: 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, at least 8 characters and not more than 12 characters'
        }
      }
    }
  },
  mounted () {
    const vm = this
    this.$validator.localize('en', {
      custom: this.errorMessages
    })
    vm.$root.$on('bv::modal::hide', vm.loginModalHideHandler)
  },
  beforeDestroy () {
    this.$root.$off('bv::modal::hide', this.loginModalHideHandler)
  },
  methods: {
    loginModalHideHandler (bvEvent, modalId) {
      const vm = this
      if (modalId === 'login-modal') {
        // check if we are at the room/_id page or not
        const excludeList = [
          'rooms-id'
        ]
        if (!excludeList.includes(vm.$router.currentRoute.name)) {
          // check if this user is authenticated or not
          if (vm.$store.getters['auth/isAuthenticated']) {
            // redirect to my-profile
            vm.$router.push('/landing-menu')
            // vm.$router.push('/my-profile')
          }
        }
      }
    },
    openModal () {
      if (this.$refs['login-modal']) {
        this.$refs['login-modal'].show()
      }
    },
    closeModal () {
      this.loginForm.email = ''
      this.loginForm.password = ''
      if (this.$refs['login-modal']) {
        this.$refs['login-modal'].hide()
      }
    },
    viewPassword () {
      if (this.loginPasswordInputType === 'password') {
        this.loginPasswordInputType = 'text'
      } else {
        this.loginPasswordInputType = 'password'
      }
    },
    validateState (ref) {
      if (process.client) {
        if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
        ) {
          return !this.veeErrors.has(ref)
        }
      }
      return null
    },
    onSubmit (e) {
      e.preventDefault()
      const vm = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          // pass!
          const loader = this.$loading.show(vm.$coopHelper.getLoadingOptions())
          this.$store.dispatch('auth/LOGIN', {
            email: this.loginForm.email,
            password: this.loginForm.password
          })
            .then((result) => {
              vm.$store.dispatch('user/GET_MY_INFO')
                .then(() => {
                  // clear input
                  vm.loginForm.email = ''
                  vm.loginForm.password = ''
                  // close login modal
                  vm.closeModal()
                })
                .catch((err) => {
                  const errMessage = this.$coopHelper.getApiErrorMessage(err)
                  let message = errMessage
                  if (errMessage === 'Not found') {
                    message = `There is a problem while you are registering. Please contact the operator at C ASEAN SAMYAN CO-OP counter to help adding membership for you.`
                  }
                  this.$bvModal.msgBoxOk(`GET INFO: ${message}`, {
                    title: 'Error',
                    size: 'sm',
                    buttonSize: 'sm',
                    // okVariant: 'danger',
                    hideHeader: true,
                    modalClass: 'coop-modal -message-box',
                    okTitle: 'CLOSE',
                    centered: true
                  })
                    .catch((error) => { console.log(error) })
                })
                .finally(() => {
                  loader.hide()
                })
            })
            .catch((err) => {
              loader.hide()
              const message = this.$coopHelper.getApiErrorMessage(err)
              this.$bvModal.msgBoxOk(`LOGIN: ${message}`, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                // okVariant: 'danger',
                hideHeader: true,
                modalClass: 'coop-modal -message-box',
                okTitle: 'CLOSE',
                centered: true
              })
                .catch((error) => { console.log(error) })
            })
        }
      })
    },
    openForgotPassword () {
      this.closeModal()
      this.$bvModal.show('forget-password-modal')
    },
    register () {
      this.closeModal()
      this.$router.push('/register')
    }
  }
}
</script>
